import { getCurrentProfile, getProfiles } from './selectors';
import { ROLES, USER_DATA_KEY } from './constants';

export const getRoleName = role => ROLES[role] || '';

export const getCurrentAuthHeader = state => ({
  Authorization: `Bearer ${getCurrentProfile(state).token}`,
});

export const saveUserInLocalStorage = (userData) => {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
};
export const getUserFromLocalStorage = () => {
  const userData = localStorage.getItem(USER_DATA_KEY);
  return JSON.parse(userData) || {};
};

export const getRoleAuthHeader = (state, role, returnCurrentOnFail = true) => {
  const profile = getProfiles(state).find(profile => profile.role === role);

  if (!profile && returnCurrentOnFail) {
    return getCurrentAuthHeader(state);
  }
  if (!profile) {
    return {
      Authorization: '',
    };
  }

  return {
    Authorization: `Bearer ${profile.token}`,
  };
};
